{
    "SignInWith_Title": "Accedi con",
    "NAME": "SignInWith",
    "SignInWith_OtherOptions": "Altre opzioni"
}